import { render, staticRenderFns } from "./formEmbed.vue?vue&type=template&id=986db2bc&scoped=true"
import script from "./formEmbed.vue?vue&type=script&lang=js"
export * from "./formEmbed.vue?vue&type=script&lang=js"
import style0 from "./formEmbed.vue?vue&type=style&index=0&id=986db2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986db2bc",
  null
  
)

export default component.exports